<div #ptConfirmCodeContainer *ngIf='confirmCodeFormGroup?.controls'
     [ngStyle]='config.containerStyles'
     class='d-flex flex-column input-code {{config.containerClass}}'>
  <form [formGroup]='confirmCodeFormGroup' class='pt-form-section-container row'>
    <label
      class='col-2 code-input-label form-label'
      for='codeInput'
    >{{ 'LABELS.CONFIRMATION_CODE' | translate }}</label>
    <div class='col-10 d-flex flex-row justify-content-start'>
      <div class='w-25 d-flex flex-row justify-content-end'>
        <input
          (keydown)='onKeyDown($event)'
          (keyup)='onKeyUp($event,i)'
          *ngFor='let item of confirmCodeFormGroup.controls | keyvalue ; let i=index'
          [formControl]='confirmCodeFormGroup.controls[item.key]' [ngStyle]='config.inputStyles'
          [placeholder]="config?.placeholder || ''" autocomplete='off'
          class='code-input {{config.inputClass}}'
          id='codeInput' id='code_{{i}}' maxlength='1'
          type='text'
        >
      </div>
    </div>
  </form>
  <div class='pt-form-section-container row'>
    <div class='col-2'></div>
    <div class='col-10 d-flex flex-row justify-content-start'>
      <div class='w-25 d-flex flex-row justify-content-end'>
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</div>
